export default __webpack_public_path__ + "static/media/cognoware_icon_Sinfondo.e235cf3f.png";